(() => {
  const initFahrzeugHero = (scope = document) => {
    scope.querySelectorAll('.slideshow-slide-fahrzeug-waehlen:not([data-fahrzeug-hero-ready])').forEach((hero) => {
      hero.setAttribute('data-fahrzeug-hero-ready', 'true');

      const controls = [...hero.querySelectorAll('[data-sku]')].filter((element) => element.tagName !== 'LI');
      const brandItems = [...hero.querySelectorAll('.fahrzeug-hero-brands li[data-sku]')];
      let pointerSku = null;
      let focusSku = null;

      const renderSkuState = () => {
        // The pointer represents the current visual hover. It must win over a
        // previous keyboard/click focus so a stale focus cannot pin another SKU.
        const activeSku = pointerSku || focusSku;
        hero.classList.toggle('fahrzeug-sku-hover-active', Boolean(activeSku));
        controls.forEach((element) => element.classList.toggle('is-active', Boolean(activeSku) && element.dataset.sku === activeSku));
        brandItems.forEach((element) => element.classList.toggle('is-active', Boolean(activeSku) && element.dataset.sku === activeSku));
      };

      const syncPointerSku = () => {
        const hoveredControl = controls.find((element) => element.matches(':hover'));
        pointerSku = hoveredControl?.dataset.sku || null;
        renderSkuState();
      };
      const syncInteractionState = () => {
        const hoveredControl = controls.find((element) => element.matches(':hover'));
        const focusedControl = controls.find((element) => element === document.activeElement || element.contains(document.activeElement));
        pointerSku = hoveredControl?.dataset.sku || null;
        focusSku = focusedControl?.dataset.sku || null;
        renderSkuState();
      };
      const scheduleInteractionSync = () => window.requestAnimationFrame(syncInteractionState);
      window.addEventListener('pageshow', scheduleInteractionSync);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) scheduleInteractionSync();
      });

      controls.forEach((element) => {
        element.addEventListener('pointerenter', () => {
          pointerSku = element.dataset.sku;
          renderSkuState();
        });
        element.addEventListener('pointerleave', () => {
          // Wait until the next hit-tested frame, so moving between a brand
          // label and its corresponding product does not clear the link state.
          window.requestAnimationFrame(syncPointerSku);
        });
        element.addEventListener('focus', () => {
          focusSku = element.dataset.sku;
          renderSkuState();
        });
        element.addEventListener('blur', () => {
          if (focusSku === element.dataset.sku) focusSku = null;
          renderSkuState();
        });
      });

      hero.querySelectorAll('button[data-sku]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = document.getElementById(`${hero.dataset.fahrzeugHero}-product-${button.dataset.sku}`);
          target?.focus({ preventScroll: true });
        });
      });

      const moreLink = hero.querySelector('[data-fahrzeug-menu-open]');
      const menuItem = document.querySelector('.et-architecture-navigation-item-fitment');
      const menuTrigger = menuItem?.querySelector('[data-fahrzeug-menu-trigger]');
      const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

      if (!moreLink || !menuItem || !menuTrigger) return;

      let closeTimer = null;
      const cancelClose = () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = null;
      };

      const setMenuOpen = (open) => {
        cancelClose();
        menuItem.classList.toggle('is-open-from-hero', open);
        menuTrigger.setAttribute('aria-expanded', String(open));
        moreLink.setAttribute('aria-expanded', String(open));
      };

      const scheduleClose = (delay = 1100) => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!moreLink.matches(':hover, :focus') && !menuItem.matches(':hover, :focus-within')) {
            setMenuOpen(false);
          }
        }, delay);
      };

      moreLink.addEventListener('pointerenter', () => {
        if (desktopHover.matches) setMenuOpen(true);
      });
      moreLink.addEventListener('pointerleave', () => {
        if (desktopHover.matches) scheduleClose();
      });
      moreLink.addEventListener('focus', () => {
        if (desktopHover.matches) setMenuOpen(true);
      });
      moreLink.addEventListener('blur', (event) => {
        if (desktopHover.matches && !menuItem.contains(event.relatedTarget)) scheduleClose(180);
      });
      moreLink.addEventListener('click', (event) => {
        if (!desktopHover.matches) return;
        event.preventDefault();
        setMenuOpen(true);
      });

      menuItem.addEventListener('pointerenter', cancelClose);
      menuItem.addEventListener('pointerleave', () => {
        if (!moreLink.matches(':hover, :focus')) setMenuOpen(false);
      });
      menuItem.addEventListener('focusin', () => {
        cancelClose();
        menuTrigger.setAttribute('aria-expanded', 'true');
      });
      menuItem.addEventListener('focusout', (event) => {
        if (!menuItem.contains(event.relatedTarget) && !moreLink.matches(':focus')) setMenuOpen(false);
      });

      document.querySelectorAll('.et-architecture-navigation > .et-architecture-navigation-item:not(.et-architecture-navigation-item-fitment)').forEach((item) => {
        item.addEventListener('pointerenter', () => setMenuOpen(false));
        item.addEventListener('focusin', () => setMenuOpen(false));
      });

      document.addEventListener('pointerdown', (event) => {
        if (!hero.contains(event.target) && !menuItem.contains(event.target)) setMenuOpen(false);
      }, true);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuItem.classList.contains('is-open-from-hero')) setMenuOpen(false);
      });
    });
  };

  initFahrzeugHero();
  document.addEventListener('shopify:section:load', (event) => initFahrzeugHero(event.target));
})();
